<template>
  <div class="wrapper" :style="styles">
    <!-- <flip-countdown deadline="2018-12-25 00:00:00"></flip-countdown> -->
    <div>
      <img class="image" :src="image.src" :alt="image.alt" :width="image.maxWidth" :style="imageStyles">
    </div>
    <vue-countdown-timer
      @start_callback="startCallBack('event started')"
      @end_callback="endCallBack('event ended')"
      :start-time="now"
      :end-time="deadline"
      :interval="1000"
      label-position="begin"
      :end-text="'Event ended!'"
      :day-txt="'days'"
      :hour-txt="'hrs'"
      :minutes-txt="'mins'"
      :seconds-txt="null">
      <!-- <template slot="start-label" slot-scope="scope">
        <span style="color: red" v-if="scope.props.startLabel !== '' && scope.props.tips && scope.props.labelPosition === 'begin'">{{scope.props.startLabel}}:</span>
        <span style="color: blue" v-if="scope.props.endLabel !== '' && !scope.props.tips && scope.props.labelPosition === 'begin'">{{scope.props.endLabel}}:</span>
      </template> -->

      <template slot="countdown" slot-scope="scope">
        <div class="timer-wrapper">
          <div class="timer-section">
            <div class="value">{{ $t(scope.props.days) }}</div>
            <div class="title">{{ $t(scope.props.dayTxt) }}</div>
          </div>
          <div class="timer-section">
            <div class="value">{{ $t(scope.props.hours) }}</div>
            <div class="title">{{ $t(scope.props.hourTxt) }}</div>
          </div>
          <div class="timer-section">
            <div class="value">{{ $t(scope.props.minutes) }}</div>
            <div class="title">{{ $t(scope.props.minutesTxt) }}</div>
          </div>
        </div>
      </template>

      <!-- <template slot="end-label" slot-scope="scope">
        <span style="color: red" v-if="scope.props.startLabel !== '' && scope.props.tips && scope.props.labelPosition === 'end'">{{scope.props.startLabel}}:</span>
        <span style="color: blue" v-if="scope.props.endLabel !== '' && !scope.props.tips && scope.props.labelPosition === 'end'">{{scope.props.endLabel}}:</span>
      </template> -->

      <!-- <template slot="end-text" slot-scope="scope">
        <span style="color: green">{{ scope.props.endText}}</span>
      </template> -->
    </vue-countdown-timer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import FlipCountdown from 'vue2-flip-countdown'
const ct = require('countries-and-timezones');

export default {
  name: 'countdown-timer',
  components: {
    // VueCountdownTimer
  },
  data () {
    return {
      now: new Date()
    }
  },
  props: {
    deadline: {
      type: String,
      default: new Date()
    },
    image: {
      type: Object,
      default () {
        return {}
      }
    },
    styles:{
      type: Object,
      default:()=>{}
    }
  },
  methods: {
    startCallBack: function (x) {
      // console.log(x);
    },
    endCallBack: function (x) {
      console.log(x);
    },
    addHours (h, date) {
      date.setTime(date.getTime() + (h*60*60*1000));
      return date;
    }
  },
  computed: {
    ...mapGetters(['hostCountry']),
    imageStyles () {
      return {
        '--max-width': this.image.maxWidth,
        '--max-mob-width': this.image.maxMobWidth
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  max-width: var(--max-width);
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    img {
      margin-bottom: 20px;
      max-width: var(--max-mob-width);
    }
  }
}
.timer-wrapper {
  display: flex;
  margin-left: 10px;
  justify-content: space-between;
  border: 1.02289px solid rgba(0, 40, 87, 0.5);
  box-sizing: border-box;
  height: 100%;
  .timer-section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px;
    .title {
      font-size: 30px;
      line-height: 55px;
      font-weight: 300;
      color: #002857;
      @media (max-width: 767px) {
        font-size: 13px;
        line-height: 16px;
      }
    }
    .value {
      font-size: 42px;
      line-height: 77px;
      font-weight: 700;
      color: #A6630D;
      @media (max-width: 767px) {
        font-size: 24px;
        line-height: 29px;
      }
    }
  }
}
</style>